import { useCallback, useEffect } from 'react'

import '@hotmart/cosmos/dist/dropdown'
import '@hotmart/cosmos/dist/select'

import { useCustomInput } from './hooks/useCustomInput'

type SelectProps = {
  placeholder: string
  name: string
  items: Array<{
    label: string
    value: number | string
  }>
  onChange: (event: Event) => void
  label?: string
  className?: string
  selected?: number
}

const CustomSelect = ({
  name,
  placeholder,
  items,
  label,
  className,
  onChange,
  selected
}: SelectProps) => {
  const { selectRef } = useCustomInput<JSX.IntrinsicElements['hot-select']>()

  useEffect(() => {
    const hotSelect = document.querySelector('hot-select')
    hotSelect?.addEventListener('change', onChange)

    return () => {
      hotSelect?.removeEventListener('change', onChange)
    }
  }, [onChange])

  const isSelected = useCallback(
    (value: string | number) => {
      return Number(value) === Number(selected) || undefined
    },
    [selected]
  )

  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} className='hot-form__label'>
          {label}
        </label>
      )}
      <hot-select id={name} class='_w-full' placeholder={placeholder} ref={selectRef}>
        {items.map((item, index) => (
          <hot-select-option
            data-test={`option-${index}`}
            key={item.label}
            value={item.value}
            selected={isSelected(item.value)}>
            {item.label}
          </hot-select-option>
        ))}
      </hot-select>
    </div>
  )
}

export default CustomSelect
